import styled, { css } from 'styled-components'
import loading from 'media/icons/spinner.svg?url'
import { breakpoints } from 'helpers/utils'

export const StyledBranch = styled.div`
	${props => props.isLoading ? `
	position: relative;
	&::before {
		content: '';
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		position: absolute;
		background: url(${loading}) no-repeat center, transparent;
	}` : ''};
width: 100%;
min-height: 297px;
height: 100%;
border-radius: 10px;
//background: linear-gradient(white, #FAFAFA, #FAFAFA, #FAFAFA, #FAFAFA);
background-color: #fcfbfd;
border: 1px solid #CDCDCD;
//position: relative;
overflow-x: hidden;
@media (max-width: 1200px) {
		min-height: 262px;
}
@media (max-width: 768px) {
		min-height: 297px;
}

@media (max-width: 590px) {
		min-height: 260px;
}
&:hover {
		cursor: pointer;
		box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
}
& .branch__header {
		padding: 15px 0 0 20px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		& h3 {
				font-size: 24px;
				font-weight: 600;
				color: #565656;
				margin-bottom: 0;
		}
		& span {
				font-size: 12px;
				font-weight: 500;
				color: #B0B0B0;
				& span {
					display: inline-block;
					margin-left: 5px;
					background-color: #8DDBCD;
					opacity: 0.75;
					color: white;
					width: ${({ isNumberBig }) => isNumberBig ? '20px' : '15.8px' };
					line-height: 15.8px;
					border-radius: 50%;
					text-align: center;
				}
		}
		@media (max-width: 1200px) {
			padding: 10px 10px 0 10px;

			& h3 {
				font-size: 18px;
				white-space: nowrap;
   				 overflow: hidden;
				text-overflow: ellipsis;
			}
		}
		@media (max-width: 768px) {
			padding: 15px 20px 0 20px;
			& h3 {
				font-size: 24px;
			}
		}
		@media (max-width: 486px) {
			padding: 10px 10px 0 10px;
			& h3 {
				font-size: 18px;
			}
		}
}
& .branch__content {
		display: flex;
		flex-direction: column;
		background-color: white;
		padding: 20px;
		margin-top: 9px;
		@media (max-width: 1200px) {
			padding: 10px;
		}
		@media (max-width: 768px) {
			padding: 20px;
		}
		@media (max-width: 486px) {
			padding: 10px;
		}
		&_block {
				&>.flexblock{
					display: flex;
					align-items: center;
					height: 30px;

					& .branch__content_block__icon{
						display: flex;
						align-items: center;
						justify-content: center;
						width: 30px;
						height: 30px;
						margin-right: 10px;
					}

					& h5{
						font-size: 10px;
						font-weight: 500;
						color: #B0B0B0;
						@media (max-width: 374px) {
							font-size: 9px;
						}
					}

					& h3{
						font-size: 18px;
						font-weight: 700;
						@media (max-width: 1200px) {
							font-size: 14px;
						}
						@media (max-width: 768px) {
							font-size: 18px;
						}
						@media (max-width: 486px) {
							font-size: 14px;
						}
						@media (max-width: 374px) {
							font-size: 10px;
						}
					}

					&.branch__content_block__top{
						height: 36px;
						@media (max-width: 1200px) {
							height: 32px;
						}
						@media (max-width: 768px) {
							height: 36px;
						}
						@media (max-width: 486px) {
							height: 32px;
						}
						& .branch__content_block__icon{
							width: 36px;
							height: 36px;
							@media (max-width: 1200px) {
								height: 32px;
								width: 32px;
							}
							@media (max-width: 768px) {
								width: 36px;
								height: 36px;
							}
							@media (max-width: 486px) {
								height: 32px;
								width: 32px;
							}
						}
						& h5{
							font-size: 12px;
							@media (max-width: 374px) {
								font-size: 10px;
							}
						}

						& h3{
							font-size: 24px;
							color: #45DB5D;
							@media (max-width: 1200px) {
								font-size: 16px;
							}
							@media (max-width: 767px) {
								font-size: 24px;
							}
							@media (max-width: 561px) {
								font-size: 19px;
							}
							@media (max-width: 486px) {
								font-size: 15px;
							}
							@media (max-width: 374px) {
								font-size: 11px;
							}
						}
					}

					&.branch__content_block__bottom{
						margin-top: 20px;
					}

					&.branch__content_block__average{
						& h3{
							color: #FFCA00;
						}
					}

					&.branch__content_block__difference{
						& h3{
							color: #45DB5D;
						}
					}

					&.branch__content_block__customers{
						& h3{
							color: #4A90E2;
						}
					}
				}
		}
}
@media (${breakpoints.mobile}) {
		max-width: 100%;
}

// FOR no access BRANCH

${({ isShopIdIsAllowed }) => !isShopIdIsAllowed && css`
background-color: #e2e2e2;
&:hover{
	cursor: default;
}
& .branch__content{
	background-color: #f2f1f1;
}
& .branch__content_block .branch__content_block__info h3{
	color: grey !important;
}
`}

`

export const StyledBranchList = styled.div`
	.branchListRow{
		.col{
			margin-bottom: 20px;
			padding-right: 10px;
    		padding-left: 10px;
			& .lazyloadWrapper{
				height: 100%;
			}
			@media (max-width: 1200px) {
				margin-bottom: 10px;
				padding-right: 5px;
    			padding-left: 5px;
			}
		}
	}
`

export const StyledRegionList = styled.div`

`

export const StyledRegionListWrapper = styled.div`
	position: absolute;
	top: 32px;
	left: 0px;
	width: 260px;
	border: 1px solid #CDCDCD;
	box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
	z-index: 15;
	border-radius: 5px;
	overflow: hidden;
	// SEARCH LINE
	& input {
		background-color: #FAFAFA;
		font-family: Montserrat;
		box-shadow: none;
		border-radius: 0px;
		padding-left: 20px;
		font-size: 14px;
		font-weight: 400;
		height: 40px;
		&::placeholder{
			color: #CDCDCD;
		}

	}
`

export const StyledRegionCard = styled.div`
	height: 56px;
	width: 100%;
	background-color: white;
	border-top: 1px solid #CDCDCD;
	padding: 6px 20px;
	cursor: pointer;
	&:hover {
		cursor: pointer;
		background-color: #F2F2F2;
	}
	& h3 {
		font-size: 18px;
		font-weight: 600;
		color: #8DDBCD;
		margin-bottom: 0px;
	}
	& .region_name {
		font-size: 12px;
		font-weight: 400;
		color: #434343;
		& .region-allowed_shops_count {
			margin-left: 5px;
			background-color: #CDCDCD;
			color: white;
			font-size: 12px;
			font-weight: 600;

			display: inline-block;
			width: ${props => props.allRegions ? '24px' : props.isNumberBig ? '20px' : '15.8px'};
			line-height: ${props => props.allRegions ? '24px' : '15.8px'};
			border-radius: 50%;
			text-align: center;

		}
		& .region-all_shops_count {
		font-weight: 600;
		text-align: center;
		line-height: ${props => props.allRegions ? '24px' : '15.8px'};}
	}
`

export const StyledCardPrototype = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
    & .branch__content_block{
        &__working_hours h3{
            color: #E25B0D;
        }
        &__hourly_turnover h3{
            color: #34CB9E;
        }
    }
`

export const StyledHeader = styled.div`
	padding-bottom: 22px;
	margin-bottom: 20px;
	& .col3{
		@media(max-width: 1200px){
			display: none;
		}
	}
	// GRADIENT LINE BETWEEN HEADER AND CONTENT
	&:after {
		position: absolute;
		content: ' ';
		height: 1px;
		width: 80%;
		top: 170px;
		z-index: 3;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(45deg, #f9f9f8, #CDCDCD, #CDCDCD, #f9f9f8);
	}
	@media (max-width: 1200px) {
		margin-bottom: 3px;
		&:after {
			top: 157px;
		}
	}
	@media (max-width: 768px) {
		padding-bottom: 25px;
		margin-top: 30px;
		& .col{
			max-width: 50%;
		}
		&:after {
			top: 193px;
		}
	}
	@media (max-width: 576px) {
		&:after {
			top: 185px;
		}
	}
	@media (max-width: 400px) {
		&:after {
			top: 179px;
		}
	}
	@media (max-height: 610px) {
		&:after {
			top: 136px;
		}
	}
	& .header_item{
		&:hover{
			& svg g g path{
				fill: #B0B0B0;
				transition: fill ease 0.4s;
			}
		}
		&:focus-within{
			& svg g g path{
				fill: #B0B0B0;
			}
		}
		& input{
			background-color: #FAFAFA;
			width: 380px;
			height: 40px;
			border-radius: 100px;
			font-family: Montserrat;
			box-shadow: none;
			padding: 10px 20px;
			font-size: 16px;
			font-weight: 400;
			border: 1px solid #CDCDCD;
			&:hover{
				&::placeholder {
					color: #B0B0B0;
				}
				border: 1px solid #B0B0B0;
				transition: border ease 0.4s;
			}
			&:focus{
				&::placeholder {
					color: #B0B0B0;
				}
				border: 1px solid #B0B0B0;
			}
		}

		& svg{
			right: 17.3px;
			order: 1;
			margin-right: 5px;
		}

		& a {
			text-decoration: none;
		}

		& .logout_wrapper {
			display: flex;
			flex-direction: row-reverse;
		}
		& .logout_wrapper .logout {
			margin-top: 13px;
			display: flex;
			flex-direction: row-reverse;
			align-items: center;
			padding-right: 4.8px;
			width: 103px;
			&:hover{
				& span {
					color: #434343;
				}
				& svg path {
					stroke: #434343;
				}
			}

			& span {
				font-size: 14px;
				font-weight: 500;
				color: #B0B0B0;
			}
		}

	}

	& .header_item_date{
		& .pickerWrapper{
			background-color: white;
		}
	}
`
